const formTypes = {
  ApplicationBanner: 'application_banner',
  ServiceBanner: 'service_banner',
  HubPageBanner: 'hubpage_banner',
  BannerContact: 'banner_contact',
  BlogSubscription: 'blog_subscription',
  Download: 'preventative-maintenance-tips-download',
  Contact: 'contact-us_page',
  Quote: 'request-a-quote',
  Service: 'contact-us_service',
  Sales: 'contact-us_sales',
  Careers: 'careers_page',
}

export default (formName, callback = null) => {
  window.dataLayer = window.dataLayer || [];

  let pushObject = {
    'event': 'formSubmission',
    'formType': formTypes[formName]
  }

  if (callback) {
    pushObject.eventCallback = callback;
  }

  window.dataLayer.push(pushObject);
}
